import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { stopPropagation } from '@fcom/core/utils/event';
import { FinnairAmount } from '@fcom/dapi/api/models/finnair-amount';

type IconSizeUnit = 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
type IconSize = `${'icon'}-${IconSizeUnit}`;

@Component({
  selector: 'fin-plus-minus-selector',
  styleUrls: ['./plus-minus-selector.component.scss'],
  templateUrl: './plus-minus-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PlusMinusSelectorComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  min: number;
  @Input()
  max: number;
  @Input()
  model: number;
  @Input()
  title: string;
  @Input()
  description: string;
  @Input()
  priceDescription: {
    text: string;
    price: FinnairAmount;
    points?: FinnairAmount;
  };
  @Input()
  decreaseLabel: string;
  @Input()
  increaseLabel: string;
  @Input()
  controls: string;
  @Input()
  iconSize?: IconSize = 'icon-large';
  @Input()
  textSize = 'font-title-small';
  @Input()
  buttonPadding = true;

  /**
   * Emits the number the value should be increased with
   * @type {EventEmitter}
   */
  @Output()
  increment: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Emits the number the value should be decreased with
   * @type {EventEmitter}
   */
  @Output()
  decrement: EventEmitter<number> = new EventEmitter<number>();

  increase(event: Event): void {
    if (this.model < this.max) {
      this.increment.emit(1);
    }
    stopPropagation(event);
  }

  decrease(event: Event): void {
    if (this.model > this.min) {
      this.decrement.emit(1);
    }
    stopPropagation(event);
  }
}
